import { BLOG_ROUTE_PREFIX, UA_ROUTE_PREFIX } from '../constants';

export const parseUrlPath = (
  path: string,
): { slug: string, isUaPage: boolean, isBlogPage: boolean, urlObject: URL } => {
  const urlObject = new URL(`https://domain.com${path}`);
  let slug = urlObject.pathname.slice(1); // Remove preceding slash

  let isUaPage = slug.startsWith(`${UA_ROUTE_PREFIX}/`);
  if (isUaPage) {
    slug = slug.slice(`${UA_ROUTE_PREFIX}/`.length);
  } else if (slug === UA_ROUTE_PREFIX) {
    isUaPage = true;
    slug = slug.slice(UA_ROUTE_PREFIX.length);
  }

  const isBlogPage = slug.startsWith(`${BLOG_ROUTE_PREFIX}/`);
  if (isBlogPage) {
    slug = slug.slice(`${BLOG_ROUTE_PREFIX}/`.length);
  }

  return { slug, isUaPage, isBlogPage, urlObject };
};
